var hacker = {};
module['exports'] = hacker;
hacker.adjective = require("./adjective");
hacker.noun = require("./noun");
hacker.verb = require("./verb");
hacker.phrase = require("./phrase");



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/nl/hacker/index.js
// module id = 3294
// module chunks = 1610